import { useContext } from 'react'
import * as React from 'react'

import type { ExploreItemMapMarker } from '../utils'

import ExploreSummaryCard from 'tripPlanner/components/TripMaps/SummaryCards/Explore/ExploreSummaryCard'
import { TripMapContext } from 'tripPlanner/contexts/TripMapContext'

interface Props {
  selectedMarker: ExploreItemMapMarker | undefined
  containerRef?: React.RefObject<HTMLDivElement>
}

function ExploreCardSingle({
  selectedMarker,
}: Props) {
  const { onDeselectMapItem } = useContext(TripMapContext)

  if (selectedMarker) {
    return (
      <ExploreSummaryCard
        item={selectedMarker.item}
        showCloseButton
        onClose={onDeselectMapItem}
      />
    )
  }
  return null
}

export default ExploreCardSingle
